import React from "react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { IconButton } from "@mui/material";
import SaveAltOutlinedIcon from "@mui/icons-material/SaveAltOutlined";

const ExportToExcel = ({ buttonDisabled, data, fileName = "report.xlsx" }) => {
    const handleExport = () => {
        if (!data || data.length === 0) {
            console.warn("No data to export");
            return;
        }

        // ✅ Convert camelCase keys → Title Case (e.g. userName → User Name)
        const formatKey = (key) =>
            key
                .replace(/([A-Z])/g, " $1")
                .replace(/^./, (s) => s.toUpperCase())
                .trim();

        // ✅ 1. Create a formatted version of your data
        const formattedData = data.map((item) => {
            const newObj = {};
            Object.keys(item).forEach((key) => {
                newObj[formatKey(key)] = item[key];
            });
            return newObj;
        });

        // ✅ 2. Convert JSON to worksheet
        const worksheet = XLSX.utils.json_to_sheet(formattedData);

        // Optional: auto column width
        const colWidths = Object.keys(formattedData[0]).map(() => ({ wch: 15 }));
        worksheet["!cols"] = colWidths;

        // ✅ 3. Create workbook
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Report");

        // ✅ 4. Export workbook
        const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array",
        });

        const blob = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        saveAs(blob, fileName);
    };

    return (
        <IconButton
            onClick={handleExport}
            disabled={buttonDisabled}
            sx={{
                border: "1px solid #3874CB",
                borderRadius: "8px",
                p: "4px",
                opacity: buttonDisabled ? 0.5 : 1,          // make it look grayed
                borderColor: buttonDisabled ? "#ccc" : "#3874CB",  // lighter border
                cursor: buttonDisabled ? "not-allowed" : "pointer",
            }}
        >
            <SaveAltOutlinedIcon sx={{ fill: buttonDisabled ? "#ccc" : "#3874CB" }} />
        </IconButton>
    );
};

export default ExportToExcel;
